// extracted by mini-css-extract-plugin
export default {"chartPlaceHolder":"Parking_chartPlaceHolder__49V+P","chartLegend":"Parking_chartLegend__DwNKp"};